export const HOME_ROUTE = '/dashboard';
export const ONBOARDING_ROUTE = '/onboarding';
export const COMMUNICATION_ROUTE = '/communication';
export const LOGOUT_ROUTE = '/logout';
export const KILL_SESSION_ROUTE = '/killSession';
